<app-vault-banners></app-vault-banners>

<app-vault-header
  [filter]="filter"
  [loading]="refreshing && !performingInitialLoad"
  [organizations]="allOrganizations"
  [canCreateCollections]="canCreateCollections"
  [collection]="selectedCollection"
  (onAddCipher)="addCipher()"
  (onAddCollection)="addCollection()"
  (onAddFolder)="addFolder()"
  (onEditCollection)="editCollection(selectedCollection.node, $event.tab)"
  (onDeleteCollection)="deleteCollection(selectedCollection.node)"
></app-vault-header>

<app-vault-onboarding [ciphers]="ciphers" [orgs]="allOrganizations" (onAddCipher)="addCipher()">
</app-vault-onboarding>

<div class="tw-flex tw-flex-row -tw-mx-2.5">
  <div class="tw-basis-1/4 tw-max-w-1/4 tw-px-2.5">
    <div class="groupings">
      <div class="content">
        <div class="inner-content">
          <app-vault-filter
            #vaultFilter
            [activeFilter]="activeFilter"
            [searchText]="currentSearchText$ | async"
            (searchTextChanged)="filterSearchText($event)"
            (onEditFolder)="editFolder($event)"
          ></app-vault-filter>
        </div>
      </div>
    </div>
  </div>
  <div class="tw-basis-3/4 tw-max-w-3/4 tw-px-2.5">
    <bit-callout type="warning" *ngIf="activeFilter.isDeleted">
      {{ trashCleanupWarning }}
    </bit-callout>
    <app-vault-items
      [ciphers]="ciphers"
      [collections]="collections"
      [allCollections]="allCollections"
      [allOrganizations]="allOrganizations"
      [disabled]="refreshing"
      [showOwner]="true"
      [showCollections]="false"
      [showGroups]="false"
      [showPremiumFeatures]="canAccessPremium"
      [showBulkMove]="showBulkMove"
      [showBulkTrashOptions]="filter.type === 'trash'"
      [useEvents]="false"
      [showAdminActions]="false"
      [showBulkAddToCollections]="vaultBulkManagementActionEnabled$ | async"
      (onEvent)="onVaultItemsEvent($event)"
      [flexibleCollectionsV1Enabled]="flexibleCollectionsV1Enabled$ | async"
      [vaultBulkManagementActionEnabled]="vaultBulkManagementActionEnabled$ | async"
    >
    </app-vault-items>
    <div
      *ngIf="performingInitialLoad"
      class="tw-mt-6 tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-start"
    >
      <i
        class="bwi bwi-spinner bwi-spin text-muted"
        title="{{ 'loading' | i18n }}"
        aria-hidden="true"
      ></i>
      <span class="tw-sr-only">{{ "loading" | i18n }}</span>
    </div>
    <div
      *ngIf="isEmpty && !performingInitialLoad"
      class="tw-mt-6 tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-start"
    >
      <bit-icon [icon]="noItemIcon" aria-hidden="true"></bit-icon>
      <p>{{ "noItemsInList" | i18n }}</p>
      <button
        type="button"
        buttonType="primary"
        bitButton
        (click)="addCipher()"
        *ngIf="filter.type !== 'trash'"
      >
        <i class="bwi bwi-plus bwi-fw" aria-hidden="true"></i>
        {{ "newItem" | i18n }}
      </button>
    </div>
  </div>
</div>

<ng-template #attachments></ng-template>
<ng-template #folderAddEdit></ng-template>
<ng-template #cipherAddEdit></ng-template>
<ng-template #share></ng-template>
<ng-template #collectionsModal></ng-template>
<ng-template #updateKeyTemplate></ng-template>
